<section class="qms-section-wrapper Auto_QMS_Section">
  <div class="title-section">
    <span class="section-title">Alerts</span>
    <div class="actions-section">
      <!--<button class="btn clear-button Auto_Clear_Alerts_Button" (click)="updateNonConformanceStatus()" [disabled]="!(status && status == 1)">Clear alerts</button>-->
      <gen-button class="qms-btn Auto_QMS_Button" (click)="openQms()" [text]="'Review in QMS'"></gen-button>
    </div>
  </div>
</section>
